import React from 'react';

const prompts = [
  'Can management force me to stay for overtime?',
  'I was bypassed for overtime. What is the rule and how do they make it right?',
  'What are my rights if I was not called in the proper order?',
  'What should a steward say if the company violated the overtime list?',
  'What does the contract say about meal allowance?',
  'How does vacation pick work?',
];

export default function ExamplePrompts({ onPick }) {
  return (
    <div
      data-testid="example-prompts"
      style={{
        borderRadius: '20px', border: '1px solid rgba(6,182,212,0.15)',
        background: 'rgba(9,9,11,0.95)', padding: '20px',
      }}
    >
      <h3 style={{
        margin: '0 0 14px', fontSize: '13px', fontWeight: 700,
        textTransform: 'uppercase', letterSpacing: '0.08em', color: '#06b6d4',
      }}>Example Questions</h3>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
        {prompts.map((prompt) => (
          <button
            key={prompt}
            onClick={() => onPick(prompt)}
            data-testid={`example-prompt-${prompts.indexOf(prompt)}`}
            style={{
              borderRadius: '999px', border: '1px solid rgba(63,63,70,0.6)',
              background: 'rgba(39,39,42,0.5)', padding: '8px 16px',
              fontSize: '13px', color: '#d4d4d8', cursor: 'pointer',
              transition: 'all 0.2s',
            }}
            onMouseEnter={e => { e.target.style.borderColor = 'rgba(6,182,212,0.5)'; e.target.style.color = '#fff'; }}
            onMouseLeave={e => { e.target.style.borderColor = 'rgba(63,63,70,0.6)'; e.target.style.color = '#d4d4d8'; }}
          >
            {prompt}
          </button>
        ))}
      </div>
    </div>
  );
}
